import { createElement } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { putNoBody } from "@common/api/apiShared";
import { Result } from "@common/api/result";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { IArchiveRiskObservationDialog } from "./ArchiveRiskObservationDialog";

export function useArchiveRiskObservationDialog(props: IArchiveRiskObservationDialog) {
    const snackbar = useDotLegalSnackbar();

    const archiveMutation = useDotLegalMutation(archive);

    const archiveObservation = () => {
        archiveMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onDialogClose();

                if (response.success()) {
                    props.onArchived();
                    snackbar.show(createElement(Trans, { i18nKey: "observationArchived", values: { name: props.observationName } }));
                }
            },
        });
    };

    async function archive() {
        return await putNoBody<string>(`/observations/${props.observationId}/archive`);
    }

    return {
        archiveObservation,
        inProgress: archiveMutation.isLoading,
    };
}
